import React from 'react'

const Expenditure = () => {
  return (
    <div>Expenditure</div>
  )
}

export default Expenditure